import { render } from "./EmailTemplateList.vue?vue&type=template&id=617bbdf1&scoped=true"
import script from "./EmailTemplateList.vue?vue&type=script&lang=js"
export * from "./EmailTemplateList.vue?vue&type=script&lang=js"

import "./EmailTemplateList.vue?vue&type=style&index=0&id=617bbdf1&lang=css"
import "./EmailTemplateList.vue?vue&type=style&index=1&id=617bbdf1&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Management_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617bbdf1"]])

export default __exports__